<template>
  <tinymce-editor class="tox-tinymce adjust-width" :api-key="api_key" cloud-channel="6-stable" :init="tinyMCEInit" v-model="content"
    :disabled="isDisabled" ref="editorRef" />
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import { nextTick } from 'vue'; // Import nextTick
import { log, error, warn } from '@/plugins/helper.js'

// const handleImageUpload = async (blobInfo, success, failure) => {

//   try {
//     const base64 = await new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = (e) => resolve(e.srcElement.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(blobInfo.blob());
//     });

//     success(base64); // Directly pass the base64 string to success

//     console.log(base64)

//   } catch (error) {
//     if (failure && typeof failure === "function") {
//       console.log(error)
//       failure(error.message);
//     }
//   }
// };

// const callBackFunc = function (cb, value, meta) {
//     const input = document.createElement('input');
//     input.setAttribute('type', 'file');
//     input.setAttribute('accept', 'image/*');

//     console.log(value)
//     console.log(meta)

//     if(meta.filetype !== 'image') {

//     }

//     input.addEventListener('change', (e) => {
//       const file = e.target.files[0];

//       const reader = new FileReader();
//       reader.addEventListener('load', () => {
//         /*
//           Note: Now we need to register the blob in TinyMCEs image blob
//           registry. In the next release this part hopefully won't be
//           necessary, as we are looking to handle it internally.
//         */
//         const id = 'blobid' + (new Date()).getTime();
//         const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
//         const base64 = reader.result.split(',')[1];
//         const blobInfo = blobCache.create(id, file, base64);
//         blobCache.add(blobInfo);

//         /* call the callback and populate the Title field with the file name */
//         cb(blobInfo.blobUri(), { title: file.name });
//       });
//       reader.readAsDataURL(file);
//     });

//     input.click();

//   };

export default {
  components: {
    tinymceEditor: Editor
  },

  props: {
    apiKey: {
      type: String,
      default: "no-api-key",
      //"ohjykkqst7yj9pz0ktkub494hihkipsr2zsf5gx6nfd31cwn"
    },
    configuration: {
      type: Object,
      default: () => ({
        width: 1500,
        resize: false,
        menubar: 'file edit insert view format table tools help',  // skip file
        plugins: 'lists link image table code help wordcount save preview',
        toolbar: 'save undo redo | preview | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
        automatic_uploads: true,
        external_plugins: {
          'preventdelete': '/js/tinymce_plugins/preventdelete/plugins.js'
        },
        preventdelete_protected_classes: ['non-editable-section'],
        noneditable_editable_class: 'editable-content-inside',
        //images_upload_handler: handleImageUpload,
        image_title: true,
        file_picker_types: 'image',
        file_picker_callback: null,
        content_style: `html { font-family:Helvetica,Arial,sans-serif !important; font-size:20px } mark { background-color: transparent !important; color: inherit !important; }`,
        font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats'; Roboto=roboto;",
        save_enablewhendirty: true,
        save_onsavecallback: () => {
          log('Saved');
          this.$emit('content-saved');
          //add save functionality here
        }

      })
    },
    css_code: {
      type: String,
      default: ""
    },
    showPricingTableButton: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      editor: null,
      tinyMCEInit: {},
      content: "",
      api_key: "no-api-key",
      isDisabled: false,
      isReady: false,
    }
  },
  beforeUnmount() {
    const editor = this.$refs.editorRef.getEditor();
    if (editor && !editor.destroyed) {
      editor.destroy();
    }
  },

  created() {
    let config = { ...this.configuration }
    let api_key = this.apiKey
    let css_code = this.css_code

    // api_key = process.env.VUE_APP_TINY_MCE_API_KEY

    if (api_key !== undefined || api_key !== "") {
      this.api_key = api_key
    } else {
      this.api_key = "no-api-key"
    }

    if (this.showPricingTableButton) {
      if (config.toolbar && !config.toolbar.includes('pricingtable')) {
        config.toolbar = config.toolbar.replace('save undo redo |', 'save undo redo | pricingtable |');
        if (!config.toolbar.includes('pricingtable')) {
          config.toolbar = 'pricingtable | ' + config.toolbar;
        }
      }
    }

    // --- Place the setup function within your config object ---
    // It will be executed by TinyMCE when the editor initializes.
    config.setup = (editor) => {
      // Register custom Pricing Table button for TinyMCE toolbar
      editor.ui.registry.addButton('pricingtable', {
        text: 'Pricing Table',
        icon: 'table',
        tooltip: 'Edit Pricing Table Settings',
        onAction: () => {
          this.$emit('open-pricing-table-modal');
        }
      });

      editor.on('click', (e) => {
        const targetButton = e.target.closest('.remove-testimonial-button');
        if (targetButton) {
          e.preventDefault(); // Prevent default button behavior

          const testimonialContainer = targetButton.closest('.testimonial-container');
          if (testimonialContainer) {
            //const id = testimonialContainer.id.replace('testimonial_hash_', '');

            // Use editor.dom to safely remove the element within TinyMCE's context
            editor.dom.remove(testimonialContainer);

            // Notify TinyMCE of the change for undo/redo and internal state
            editor.undoManager.add();
            editor.fire('change');

            //console.log(`Testimonial ID ${id} removed via TinyMCE setup function.`);

            // If you need to update Vue component data here:
            // You might need to use a closure or emit an event to a parent component.
            // For example: this.$emit('testimonial-removed-from-editor', id);
          }
        }

        const pricingBtn = e.target.closest('.btn-open-pricing-modal, .edit-pricing-table-button');
        if (pricingBtn) {
          e.preventDefault();
          this.$emit('open-pricing-table-modal');
        }
      });
      editor.on('change', () => {
        // Call a method in your Vue component to handle the change
        this.handleEditorChange();
      });
    };
    // --- End of setup function placement ---


    if (config.file_picker_callback == undefined || config.file_picker_callback == null)
      config.file_picker_callback = (cb, value, meta) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        log(value)
        log(meta)

        input.addEventListener('change', (e) => {
          const file = e.target.files[0];

          const reader = new FileReader();
          reader.addEventListener('load', () => {
            const id = 'blobid' + (new Date()).getTime();
            const blobCache = this.$refs.editorRef.getEditor().editorUpload.blobCache;
            const base64 = reader.result.split(',')[1];
            const blobInfo = blobCache.create(id, file, base64);
            blobCache.add(blobInfo);

            /* call the callback and populate the Title field with the file name */
            cb(blobInfo.blobUri(), { title: file.name });
          });
          reader.readAsDataURL(file);
        });
        input.click();
      }

    if (css_code != "") {
      config.content_style = css_code
    }

    config.init_instance_callback = (editor) => {
        this.isReady = true;
        this.editor = editor;
        log('TinyMCE Initialized via Callback');
        this.$emit('editor-ready', editor); // Emit a specific event
    };

    this.tinyMCEInit = config
  },

  mounted() {

    nextTick(() => {

      this.$emit('component-loaded'); // Emit the event

      // const editor = this.$refs.editorRef.getEditor();
      // if (editor && editor.isDirty()) {
      //   this.$emit('has-unsaved-changes', true);
      // }
    });
  },

  methods: {

    handleEditorChange() {
      const editor = this.$refs.editorRef.getEditor();
      if (editor && editor.isDirty()) {
        // The editor is dirty, emit an event
        this.$emit('has-unsaved-changes', true);
      } else {
        // The editor is not dirty (e.g., after an undo that restores a clean state)
        this.$emit('has-unsaved-changes', false);
      }
    },

    addContent(content) {
      nextTick(() => {
        this.$refs.editorRef.getEditor().insertContent(content); // Append to existing content (where your text cursor is)
      })
    },

    checkIfIDExist(string_id) {
      // It's good practice to ensure the editor instance is available
      // before attempting to interact with it.
      const editor = this.$refs.editorRef.getEditor();

      if (!editor) {
        warn("TinyMCE editor instance not available yet when checking ID.");
        return false; // Cannot check if editor is not ready
      }

      // Use editor.dom.get() to check for the element by its ID within the editor's content.
      // This method returns the DOM element if found, or null if not found.
      const element = editor.dom.get(string_id);

      if (element) {
        return true;
      } else {
        return false;
      }
    },

    setContent(content, isDisabled) {
      nextTick(() => {
        if (this.$refs.editorRef)
          if (this.$refs.editorRef.getEditor())
            this.$refs.editorRef.getEditor().setContent(content); //Note: it will set the whole content of the editor to this content

        this.isDisabled = isDisabled
      })
    },

    /**
   * Dynamically adds a new testimonial to the grid within the TinyMCE editor.
   * - If a grid wrapper exists, it prepends the testimonial.
   * - If no grid wrapper exists, it creates a new grid wrapper with the testimonial inside.
   *
   * This is the method you should call when clicking a button to "add" a new testimonial.
   * @param {Object} newTestimonialData - The data object for the new testimonial to add.
   */
    addTestimonialToGrid(newTestimonialData, testimonialHTML) {
      const editor = this.$refs.editorRef.getEditor();
      if (!editor) {
        warn("TinyMCE editor instance not available. Cannot add testimonial to grid.");
        return;
      }

      // Generate the HTML for the single new testimonial using your provided structure
      const newTestimonialHtml = testimonialHTML

      const gridWrapper = editor.dom.select('.testimonials-grid-wrapper')[0];

      if (!gridWrapper) {
        // Create a new grid wrapper if none exists
        const fullNewGridHtml = `<div class="testimonials-grid-wrapper">${newTestimonialHtml}</div>`;
        editor.insertContent(fullNewGridHtml);
        log(`Testimonial ID ${newTestimonialData.id} added in a new grid wrapper.`);
        return;
      }

      console.log('Existing grid wrapper found:', gridWrapper);

      // 4. Now, append the new testimonial to the gridWrapper
      const tempDiv = editor.dom.create('div');
      editor.dom.setHTML(tempDiv, newTestimonialHtml);


      //const newTestimonialElement = tempDiv.firstChild;

      //console.log(newTestimonialElement)

      if (tempDiv) {
        editor.dom.add(gridWrapper, tempDiv, false); // false for append
        log(`Testimonial ID ${newTestimonialData.id} appended to grid.`);
      } else {
        error('Failed to create new testimonial element from HTML string. newTestimonialElement is null.');
      }

      // 5. Crucial: Notify TinyMCE of the change for undo/redo and internal state
      editor.undoManager.add();
      editor.fire('change');
      log('TinyMCE undoManager and change fired.');
    },

    isEmptyTinyMCEPlaceholder(element) {
      if (!element || !element.childNodes) {
        return true; // Consider it empty if no children or element is null
      }

      // Check if it contains only a single element that is a common placeholder
      if (element.childNodes.length === 1 && element.firstChild.nodeType === Node.ELEMENT_NODE) {
        const node = element.firstChild;
        const tagName = node.tagName.toLowerCase();
        const innerHtml = node.innerHTML.trim();
        // Check for common empty tags with/without &nbsp;
        if ((tagName === 'div' || tagName === 'p') && (innerHtml === '' || innerHtml === '&nbsp;' || innerHtml === '&#160;' || innerHtml === String.fromCharCode(160))) {
          return true;
        }
      } else if (element.childNodes.length === 0 || element.innerHTML.trim() === '') {
        // Check if it's truly empty (no children or only whitespace)
        return true;
      }
      // If it contains anything else, it's not considered an empty placeholder
      return false;
    },

    /**
     * Extracts the HTML content of a single, specific section by its full ID.
     *
     * @param {string} sectionId The full ID of the section div (e.g., 'start_product_services_section').
     * @returns {string|null} The innerHTML of the specified section, or null if not found.
     */
    getSectionContentById(sectionId) {
      const editor = this.$refs.editorRef.getEditor();
      if (!editor) {
        warn("TinyMCE editor instance not available to get section content by ID.");
        return null; // Return null if editor is not ready
      }

      const fullEditorContent = editor.getContent();

      // Parse the full editor content into a temporary DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(fullEditorContent, 'text/html');

      // Use querySelector to find the exact element by its ID
      // Prepend '#' to the ID to make it a valid CSS selector
      const sectionDiv = doc.querySelector(`#${sectionId}`);

      if (sectionDiv) {
        log(`Content for section '${sectionId}' retrieved successfully.`);
        return sectionDiv.innerHTML;
      } else {
        warn(`Section with ID '${sectionId}' not found in editor content.`);
        return null; // Return null if the section div is not found
      }
    },

    /**
     * Replaces the HTML content of a single, specific section within the TinyMCE editor.
     *
     * @param {string} sectionId The full ID of the section div (e.g., 'start_product_services_section').
     * @param {string} newHtmlContent The new HTML string to set inside the specified section.
     * @returns {void}
     */
    setSectionContentById(sectionId, newHtmlContent) {
      const editor = this.$refs.editorRef.getEditor();
      if (!editor) {
        warn("TinyMCE editor instance not available to set section content by ID.");
        return;
      }

      // 1. Get the entire current HTML content from the editor
      const fullEditorContent = editor.getContent();

      // 2. Parse the full editor content into a temporary DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(fullEditorContent, 'text/html');

      // 3. Find the specific section div within the temporary DOM
      const sectionDiv = doc.querySelector(`#${sectionId}`);

      if (sectionDiv) {
        // 4. Replace the innerHTML of the found section div with the new content
        sectionDiv.innerHTML = newHtmlContent;
        log(`Content for section '${sectionId}' replaced successfully.`);

        // 5. Set the entire editor content back with the modified HTML string.
        //    This forces TinyMCE to re-render the updated content.
        //    Use doc.body.innerHTML to get the content of the <body> tag from your parsed document.
        editor.setContent(doc.body.innerHTML);

        // 6. Notify TinyMCE of the change for undo/redo and dirty state
        editor.undoManager.add();
        editor.fire('change');
      } else {
        warn(`Section with ID '${sectionId}' not found in editor content. Cannot replace content.`);
      }
    },

    /**
     * Natively find text inside the iframe and apply highlight 
     */
    /**
     * Natively find text inside the iframe and apply highlight 
     */
    findAndHighlight(textToFind) {
      const editor = this.$refs.editorRef.getEditor();
      if (!editor) return false;
      const win = editor.getWin();
      const doc = editor.getDoc();
      const container = editor.getBody();
      
      // Extract clean payload from DB structure
      let cleanText = textToFind;
      if (cleanText.startsWith(">>>")) {
          let textStart = cleanText.indexOf(':\n"');
          if (textStart === -1) textStart = cleanText.indexOf(':\r\n"');
          
          if (textStart !== -1) {
              const isWindows = cleanText.substr(textStart, 4) === ':\r\n"';
              const contentBody = cleanText.slice(textStart + (isWindows ? 4 : 3)); 
              
              let lastQuoteNewline = contentBody.indexOf('"\n\n');
              if (lastQuoteNewline === -1) {
                  lastQuoteNewline = contentBody.indexOf('"\r\n\r\n');
              }
              // Fallback to lastIndexOf
              if (lastQuoteNewline === -1) {
                  lastQuoteNewline = contentBody.lastIndexOf('"\n\n');
              }
              if (lastQuoteNewline === -1) {
                  lastQuoteNewline = contentBody.lastIndexOf('"\r\n\r\n');
              }
              
              if (lastQuoteNewline !== -1) {
                   cleanText = contentBody.substring(0, lastQuoteNewline);
              } else if (contentBody.endsWith('"')) {
                   cleanText = contentBody.substring(0, contentBody.length - 1);
              } else {
                   cleanText = contentBody;
              }
          }
      }

      cleanText = cleanText.trim();
      if (cleanText.length === 0) return false;

      // Helper: normalize all quote variants and non-breaking spaces to straight quotes and normal spaces
      const normalizeQuotesAndSpaces = (str) => str
          .replace(/[\u201C\u201D\u201E\u201F\u2033\u2036]/g, '"')
          .replace(/[\u2018\u2019\u201A\u201B\u2032\u2035]/g, "'")
          .replace(/\u00AB|\u00BB/g, '"')
          .replace(/\u00A0/g, ' ');

      const BLOCK_TAGS = new Set([
        'address', 'article', 'aside', 'blockquote', 'details', 'dialog', 'dd', 'div', 'dl', 'dt',
        'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'header', 'hgroup', 'hr', 'li', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'tbody',
        'td', 'tfoot', 'th', 'thead', 'tr', 'ul'
      ]);

      const nodes = [];
      let unifiedString = "";

      const walk = (node) => {
          if (node.nodeType === 3) { // TEXT_NODE
              const text = node.nodeValue;
              nodes.push({ node, start: unifiedString.length, end: unifiedString.length + text.length });
              unifiedString += text;
          } else if (node.nodeType === 1) { // ELEMENT_NODE
              const tagName = node.tagName.toLowerCase();
              if (tagName === 'br') {
                  if (unifiedString.length > 0 && !unifiedString.endsWith('\n')) {
                      unifiedString += '\n';
                  }
                  return;
              }

              const isBlock = BLOCK_TAGS.has(tagName);
              if (isBlock && unifiedString.length > 0 && !unifiedString.endsWith('\n') && !unifiedString.endsWith(' ')) {
                  unifiedString += '\n';
              }

              for (let child = node.firstChild; child; child = child.nextSibling) {
                  walk(child);
              }

              if (isBlock && unifiedString.length > 0 && !unifiedString.endsWith('\n') && !unifiedString.endsWith(' ')) {
                  unifiedString += '\n';
              }
          }
      };

      walk(container);
      
      // Normalize both strings: collapse whitespace + normalize quotes/spaces
      const normalizedUnified = normalizeQuotesAndSpaces(unifiedString).replace(/\s+/g, ' ');
      const normalizedSearch = normalizeQuotesAndSpaces(cleanText).replace(/\s+/g, ' ');
      
      // Simple substring search on normalized strings
      const matchPos = normalizedUnified.toLowerCase().indexOf(normalizedSearch.toLowerCase());

      if (matchPos !== -1) {
          // Map the normalized position back to the original unifiedString position
          const origToNorm = [];
          let prevWasSpace = false;
          for (let k = 0; k < unifiedString.length; k++) {
              const ch = unifiedString[k];
              const isSpace = /\s/.test(ch);
              if (isSpace && prevWasSpace) {
                  continue;
              }
              origToNorm.push(k);
              prevWasSpace = isSpace;
          }
          
          const origStart = origToNorm[matchPos] !== undefined ? origToNorm[matchPos] : matchPos;
          const endNorm = matchPos + normalizedSearch.length - 1;
          const origEnd = (origToNorm[endNorm] !== undefined ? origToNorm[endNorm] : endNorm) + 1;
          
          const nodesToWrap = [];
          for (let idx = 0; idx < nodes.length; idx++) {
              const n = nodes[idx];
              if (n.end > origStart && n.start < origEnd) {
                   const localStart = Math.max(0, origStart - n.start);
                   const localEnd = Math.min(n.node.nodeValue.length, origEnd - n.start);
                   if (localStart < localEnd) {
                       nodesToWrap.push({ node: n.node, start: localStart, end: localEnd });
                   }
              }
          }

          if (nodesToWrap.length > 0) {
              const range = doc.createRange();
              range.setStart(nodesToWrap[0].node, nodesToWrap[0].start);
              range.setEnd(nodesToWrap[nodesToWrap.length - 1].node, nodesToWrap[nodesToWrap.length - 1].end);
              
              // Focus editor so highlight is visible and active
              editor.focus();
              
              // Apply browser native selection first
              win.getSelection().removeAllRanges();
              win.getSelection().addRange(range);
              
              // Sync selection to TinyMCE
              if (editor.selection && editor.selection.setRng) {
                 editor.selection.setRng(range);
              }
              
              // Prioritize node vertical centering for optimal user visibility
              const nodeToScroll = editor.selection.getNode();
              if (nodeToScroll && nodeToScroll.scrollIntoView) {
                 nodeToScroll.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } else if (editor.selection && editor.selection.scrollIntoView) {
                 editor.selection.scrollIntoView();
              }
              return true;
          }
      } else {
         console.warn(`Could not trace textual indices across DOM tree for highlight extraction.`);
         log("Could not natively find text in editor: " + textToFind);
      }
      return false;
    },

    scrollToElement(sectionId) {
      const editor = this.$refs.editorRef.getEditor();
      if (!editor) return;
      
      const sectionNode = editor.dom.get(sectionId);
      if (sectionNode) {
          sectionNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },

    /**
    * Appends new HTML content to an existing section within the TinyMCE editor.
    *
    * @param {string} sectionId The full ID of the target section div (e.g., 'start_product_services_section').
    * @param {string} htmlToAppend The HTML string to append to the section's current content.
    * @returns {void}
    */
    appendToSectionContentById(sectionId, htmlToAppend) {
      const editor = this.$refs.editorRef.getEditor();
      if (!editor) {
        warn("TinyMCE editor instance not available to append content to section.");
        return;
      }

      // 1. Get the entire current HTML content from the editor
      const fullEditorContent = editor.getContent();

      // 2. Parse the full editor content into a temporary DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(fullEditorContent, 'text/html');

      // 3. Find the specific section div within the temporary DOM
      const sectionDiv = doc.querySelector(`#${sectionId}`);

      if (sectionDiv) {
        // 4. Append the new HTML content to the innerHTML of the found section div
        sectionDiv.innerHTML += htmlToAppend; // Key change: += instead of =
        log(`Content appended to section '${sectionId}' successfully.`);

        // 5. Set the entire editor content back with the modified HTML string.
        //    This forces TinyMCE to re-render the updated content.
        editor.setContent(doc.body.innerHTML);

        // 6. Notify TinyMCE of the change for undo/redo and dirty state
        editor.undoManager.add();
        editor.fire('change');
      } else {
        warn(`Section with ID '${sectionId}' not found in editor content. Cannot append content.`);
      }
    },

    /**
    * Checks if the TinyMCE editor content has been modified.
    *
    * @returns {boolean} True if the editor content has changed, false otherwise.
    */
    isEditorContentDirty() {
      const editor = this.$refs.editorRef.getEditor();

      if (!editor) {
        warn("TinyMCE editor instance not available to check dirty state.");
        return false; // Or throw an error, depending on desired error handling
      }

      const isDirty = editor.isDirty();
      return isDirty;
    },

    /**
     * Optional: Method to explicitly mark the editor as clean (not dirty).
     * This is typically called after content has been successfully saved.
     */
    markEditorContentClean() {
      const editor = this.$refs.editorRef.getEditor();
      if (editor) {
        editor.setDirty(false);
        log("TinyMCE editor marked as clean.");
      }
    },

    setTestimonialContent(content) {
      nextTick(() => {
        if (this.$refs.editorRef)
          if (this.$refs.editorRef.getEditor())
            this.$refs.editorRef.getEditor().setContent(content); //Note: it will set the whole content of the editor to this content
      })
    },

    getContent() {
      return this.$refs.editorRef.getEditor().getContent(); //Gets all the content.... duh?
    },
    setToDisabled() {
      this.isDisabled = true
    }
  },
};
</script>

<style scoped>
#sample {
  display: flex;
  flex-direction: column;
  place-items: center;
  width: 1500px;
}

.tox-tinymce {
  height: 1000px;
}

.adjust-width {
  min-width: 1000px;
}
</style>